export default __webpack_public_path__ + "static/media/283.fc3e5f88.png";